/** Account area tabs (Phase 2b) — canonical paths under /account/*. */

export type AccountSectionTab = {
  id: string;
  label: string;
  to: string;
  description?: string;
};

export const ACCOUNT_SECTION_TABS: AccountSectionTab[] = [
  { id: 'profile', label: 'Profile', to: '/account', description: 'Name, photo, contact' },
  { id: 'orders', label: 'Orders', to: '/account/orders', description: 'Purchases & delivery' },
  { id: 'bookings', label: 'Bookings', to: '/account/bookings', description: 'Appointments & hire' },
  { id: 'returns', label: 'Returns', to: '/account/returns' },
  { id: 'wishlist', label: 'Wishlist', to: '/account/wishlist' },
  { id: 'messages', label: 'Messages', to: '/account/messages' },
  { id: 'notifications', label: 'Notifications', to: '/account/notifications', description: 'SMS & WhatsApp' },
  { id: 'cards', label: 'Payment cards', to: '/account/cards' },
  { id: 'loyalty', label: 'Loyalty', to: '/account/loyalty' },
  { id: 'referral', label: 'Referrals', to: '/account/referral' },
  { id: 'gift-cards', label: 'Gift cards', to: '/account/gift-cards' },
];

/** Legacy shopper account paths → canonical /account/* URLs. */
export const ACCOUNT_LEGACY_PATH_REDIRECTS: Record<string, string> = {
  '/orders': '/account/orders',
  '/wishlist': '/account/wishlist',
  '/returns': '/account/returns',
  '/requests': '/account/bookings',
  '/messages': '/account/messages',
  '/notification-prefs': '/account/notifications',
  '/saved-cards': '/account/cards',
  '/loyalty': '/account/loyalty',
  '/referral': '/account/referral',
  '/gift-cards': '/account/gift-cards',
  '/gift-certificates': '/account/gift-cards',
};

export function accountTabIsActive(pathname: string, tab: AccountSectionTab): boolean {
  if (tab.to === '/account') {
    return pathname === '/account' || pathname === '/account/';
  }
  return pathname === tab.to || pathname.startsWith(`${tab.to}/`);
}
